export const REGEX_EMAIL = /^[\w-.]+@([\w-]+\.)+[\w-]{2,}$/;
export const REGEX_PASSWORD: RegExp =
  /^(?=[^A-Z]*[A-Z])(?=[^a-z]*[a-z])(?=\D*\d).{8,}$/;
export const REGEX_SSN = /^\d{3}-\d{3}-\d{3}$/;
